// Auto-generated cornerstone translation for it.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:33:32.543825+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "App gestione cavalli: la scelta migliore per il 2026 | EquiSight",
      description: "Confronta le app di gestione cavalli per proprietari, scuderie e allevamenti. Scopri perché EquiSight è l'app completa per il tuo cavallo.",
      keywords: [
        "app gestione cavalli",
        "app gestione scuderia",
        "diario digitale cavalli",
        "app per gestire più cavalli",
        "app gravidanza cavalla",
        "app allevamento cavalli",
        "migliore app gestione cavalli",
      ],
    },
    hero: {
      eyebrow: "Guida alla scelta · software gestione cavalli",
      breadcrumbLabel: "App gestione cavalli",
      title: "App gestione cavalli: la guida completa per proprietari, scuderie e allevatori.",
      intro: "Non una semplice lista di funzionalità — un confronto onesto, una guida alla scelta e uno sguardo a ciò che un'app di gestione cavalli deve davvero saper fare nel 2026. Per un solo cavallo, per un'intera scuderia o per il tuo allevamento.",
      pills: [
        {
          icon: "Users",
          label: "Per i proprietari",
        },
        {
          icon: "Building2",
          label: "Per le scuderie",
        },
        {
          icon: "Baby",
          label: "Per gli allevatori",
        },
        {
          icon: "Share2",
          label: "Per i team",
        },
      ],
      ctas: [
        {
          label: "Inizia gratis con 1 cavallo",
          href: "#start",
          primary: true,
        },
        {
          label: "Vai alla tabella comparativa",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Perché un'app di gestione cavalli diventa sempre più importante.",
      lead: "Nella pratica, la gestione dei cavalli è frammentata: WhatsApp, agenda, Excel, foto sul telefono, un passaporto cartaceo, fatture sparse e accordi verbali. Già con un solo cavallo è scomodo. Con più cavalli, allevamenti o cure condivise si creano lacune, appuntamenti mancati e incomprensioni.",
      items: [
        "Dov'era scritta quella data di vaccinazione?",
        "Chi ha pagato il maniscalco?",
        "Quale cavalla va controllata oggi?",
        "Il trainer ha letto le istruzioni della settimana scorsa?",
        "Ho davvero salvato quella foto-documento?",
        "Il piano alimentare appeso in scuderia è ancora aggiornato?",
      ],
    },
    what: {
      title: "Cos'è un'app di gestione cavalli?",
      lead: "Un'app di gestione cavalli è essenzialmente un fascicolo digitale per ogni cavallo. Niente note sparse, ma un unico posto per salute, allenamento, alimentazione, documenti, pianificazione, promemoria, costi, foto, video e accesso condiviso. Tutti intorno al cavallo guardano le stesse informazioni aggiornate.",
      targetGroupsTitle: "A chi è destinata un'app di gestione cavalli?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Proprietario privato",
          body: "Un cavallo, un fascicolo — salute, pianificazione e storico sempre in tasca.",
        },
        {
          icon: "Users",
          title: "Proprietario di più cavalli",
          body: "Profili separati, pianificazione separata, lista di attività condivisa per tutto il team.",
        },
        {
          icon: "Building2",
          title: "Scuderia a pensione & maneggio",
          body: "Accesso per i proprietari, istruzioni di cura, agenda condivisa e attività.",
        },
        {
          icon: "Baby",
          title: "Allevamento",
          body: "Ciclo della cavalla, gravidanza, dati dello stallone, pedigree e sviluppo del puledro.",
        },
        {
          icon: "Target",
          title: "Trainer",
          body: "Panoramica per cavallo, registrazione delle sessioni, definizione degli obiettivi, analisi dei video.",
        },
        {
          icon: "ClipboardList",
          title: "Professionisti",
          body: "Maniscalco, dentista equino, fisioterapista o veterinario — lavorano tutti dallo stesso fascicolo.",
        },
      ],
    },
    criteria: {
      title: "Cosa deve avere una buona app di gestione cavalli?",
      lead: "Un'app non deve solo essere bella — deve funzionare in modo pratico ogni giorno. Cinque elementi indispensabili nella scelta del 2026.",
      items: [
        {
          icon: "FileText",
          title: "Fascicolo per ogni cavallo",
          body: "Dati, età, razza, informazioni del passaporto, proprietario, scuderia, foto e documenti — tutto collegato a un unico profilo del cavallo.",
        },
        {
          icon: "Heart",
          title: "Salute e cura",
          body: "Vaccinazioni, sverminazione, maniscalco, dentista equino, veterinario, trattamenti, farmaci e promemoria automatici prima della scadenza.",
        },
        {
          icon: "Activity",
          title: "Allenamento e progressi",
          body: "Registrazione degli allenamenti, note, video, risultati in gara, obiettivi e progressi per disciplina o per cavallo.",
        },
        {
          icon: "Apple",
          title: "Alimentazione e gestione",
          body: "Piani alimentari, integratori, foraggi, peso, condizione corporea e la routine quotidiana che la scuderia deve conoscere.",
        },
        {
          icon: "Share2",
          title: "Condivisione con altri",
          body: "Accesso per proprietario, stalliere, trainer, gestore della scuderia o professionista — con gestione dei permessi adatta al ruolo di ciascuno.",
        },
        {
          icon: "Calendar",
          title: "Pianificazione e promemoria",
          body: "Un'agenda condivisa con attività, promemoria automatici e conferme affinché nulla vada perso.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs altre app di gestione cavalli.",
      lead: "I principali concorrenti presenti online includono Stalmanager, LogMyHorse, EquineM e Happie Horse. Ognuno ha i suoi punti di forza. Mettiamo a confronto le funzionalità più richieste, in modo onesto e sulla base di informazioni pubblicamente disponibili.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Inizia gratis",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Più cavalli",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Fascicolo sanitario",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Allenamento e progressi",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Alimentazione e integratori",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Pianificazione e promemoria",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Documenti per cavallo",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Condivisione team e permessi",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Modulo allevamento (completo)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Ciclo della cavalla",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Pianificazione gravidanza + ecografie",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sviluppo del puledro",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrazione professionisti",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Approfondimenti EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adatto ai proprietari",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Adatto agli allevatori",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adatto a scuderia/maneggio",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Confronto basato sulle funzionalità pubblicamente disponibili a gennaio 2026. I concorrenti sono anch'essi buoni strumenti; EquiSight è stato costruito per combinare tutti i moduli in un'unica app.",
    },
    why: {
      title: "Perché EquiSight è diverso.",
      lead: "Un diario registra. EquiSight combina gestione del cavallo, allenamento, alimentazione, salute, gare, professionisti e allevamento in un'unica app moderna — e va oltre con approfondimenti e analisi.",
      points: [
        {
          icon: "Heart",
          title: "Un'unica app per tutta la vita del cavallo",
          body: "Dal puledro al cavallo sportivo, dalla cavalla da riproduzione al cavallo in pensione. Il fascicolo cresce con il tuo cavallo — niente va perso lungo la strada.",
        },
        {
          icon: "Sparkles",
          title: "Non solo dati, anche tendenze",
          body: "EquiCoach combina sviluppo, problemi ricorrenti, allenamento e alimentazione — così individui i segnali in anticipo, non come notifiche isolate.",
        },
        {
          icon: "Share2",
          title: "Costruito per la collaborazione",
          body: "Proprietario, gestore della scuderia, trainer, maniscalco e altri professionisti lavorano dallo stesso fascicolo del cavallo — con i permessi adatti al loro ruolo.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Nicchia · allevamento",
      title: "Gestione cavalli per gli allevatori.",
      lead: "Molti concorrenti menzionano l'allevamento in una riga. EquiSight ha sviluppato un modulo di allevamento completo — perché l'allevatore raramente è l'utente finale di un'app generica, ma ha bisogno di pianificazione più di chiunque altro.",
      items: [
        "Monitoraggio giornaliero del ciclo della cavalla",
        "Data di inseminazione + dati dello stallone",
        "Controllo gravidanza con ecografie",
        "Data prevista del parto + avvisi",
        "Sviluppo del puledro mese per mese",
        "Pedigree e discendenza",
        "Note per ogni cavalla",
        "Panoramica di tutte le cavalle gravide",
      ],
      ctaLabel: "Scopri il modulo allevamento",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Nicchia · scuderia & maneggio",
      title: "Gestione cavalli per più cavalli e scuderie a pensione.",
      lead: "Con più cavalli, il focus non è tanto sui dati quanto sulla comunicazione. Ogni proprietario ha le proprie esigenze, routine, accordi sull'alimentazione e punti di attenzione medica. Ogni membro del personale deve potervi accedere senza dover cercare.",
      cards: [
        {
          t: "Cavalli per proprietario",
          d: "Ogni proprietario vede solo i propri cavalli.",
        },
        {
          t: "Istruzioni di cura",
          d: "Visibili per ogni cavallo al personale della scuderia.",
        },
        {
          t: "Agenda condivisa",
          d: "Maniscalco, veterinario e gare in un'unica vista.",
        },
        {
          t: "Lista attività",
          d: "Assegnata ai dipendenti, con conferma.",
        },
        {
          t: "Accesso proprietari",
          d: "I clienti vedono il loro cavallo nella propria app.",
        },
        {
          t: "Contatti d'emergenza",
          d: "Sempre reperibili in caso di urgenza in scuderia.",
        },
      ],
      ctaLabel: "Scopri il modulo maneggio",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Da WhatsApp, Excel e lavagna a EquiSight.",
      lead: "In concreto: ecco come cambia la tua gestione quotidiana dei cavalli.",
      rows: [
        {
          before: "Gruppi WhatsApp",
          after: "Note strutturate per ogni cavallo",
        },
        {
          before: "Fogli Excel",
          after: "Fascicolo digitale aggiornato in tempo reale",
        },
        {
          before: "Lavagna in scuderia",
          after: "Pianificazione condivisa sul tuo telefono",
        },
        {
          before: "Foto sparse nella galleria",
          after: "Media collegati al tuo cavallo",
        },
        {
          before: "Accordi verbali",
          after: "Attività e promemoria con conferma",
        },
        {
          before: "Passaporto cartaceo introvabile",
          after: "Documenti sempre a portata di mano",
        },
      ],
    },
    helper: {
      title: "Quale app di gestione cavalli fa per te?",
      lead: "Rispondi a queste 5 domande e riceverai una raccomandazione onesta — anche quando non è sempre EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Hai uno o più cavalli?",
          options: [
            {
              label: "Un solo cavallo",
              score: 1,
            },
            {
              label: "2–5 cavalli",
              score: 2,
            },
            {
              label: "Più di 5 cavalli",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Gestisci cavalli di clienti o terzi?",
          options: [
            {
              label: "No, solo i miei cavalli",
              score: 0,
            },
            {
              label: "A volte — per familiari o conoscenti",
              score: 1,
            },
            {
              label: "Sì, in modo professionale (scuderia / maneggio)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Vuoi tenere traccia dell'allevamento e della gravidanza?",
          options: [
            {
              label: "Non rilevante",
              score: 0,
            },
            {
              label: "A volte — allevamento occasionale",
              score: 1,
            },
            {
              label: "Sì, sono (o diventerò) un allevatore",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Collabori con un trainer, uno stalliere o un professionista?",
          options: [
            {
              label: "No, faccio tutto da solo",
              score: 0,
            },
            {
              label: "Sì, con una persona",
              score: 1,
            },
            {
              label: "Sì, con più persone",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vuoi solo registrare o anche ottenere approfondimenti?",
          options: [
            {
              label: "Solo registrare",
              score: 1,
            },
            {
              label: "Registrare + pianificare",
              score: 2,
            },
            {
              label: "Registrare + pianificare + approfondimenti",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Un semplice diario è sufficiente — e cresce con te.",
          body: "Per un solo cavallo senza cura condivisa, qualsiasi app di gestione cavalli è adatta. EquiSight inizia gratuitamente con 1 cavallo, quindi non hai nulla da rischiare. Se in seguito vorrai aggiungere più cavalli, un trainer o l'allevamento, troverai tutto già incluso.",
          cta: "Inizia gratis con 1 cavallo",
        },
        mid: {
          title: "EquiSight si adatta bene alla tua situazione.",
          body: "Hai più esigenze (più cavalli, collaborazione o approfondimenti). La maggior parte dei concorrenti copre 1-2 moduli; EquiSight li combina in un'unica app, senza dover collegare strumenti separati.",
          cta: "Scopri cosa può fare EquiSight",
        },
        high: {
          title: "EquiSight è la scelta più logica.",
          body: "La tua situazione combina più cavalli, collaborazione, allevamento e/o approfondimenti. È esattamente qui che EquiSight fa la differenza — nessuno strumento frammentato, ma un unico fascicolo per tutto e tutti intorno al cavallo.",
          cta: "Inizia gratis con EquiSight",
        },
      },
    },
    faqTitle: "Domande frequenti sulle app di gestione cavalli",
    faq: [
      {
        q: "Qual è la migliore app di gestione cavalli?",
        a: "La migliore app di gestione cavalli dipende dalla tua situazione. Per un semplice diario ci sono più app adatte. Se vuoi combinare salute, allenamento, alimentazione, documenti, allevamento, pianificazione e collaborazione, EquiSight è stato sviluppato come soluzione completa in cui tutto confluisce in un unico fascicolo.",
      },
      {
        q: "Posso gestire più cavalli in un'unica app?",
        a: "Sì. Una buona app di gestione cavalli deve supportare più cavalli, inclusi proprietari, stallieri, routine, documenti, appuntamenti e promemoria per ogni cavallo. EquiSight è stato progettato con questo obiettivo fin dalla prima riga di codice — i cavalli sono fascicoli individuali, non righe in un elenco.",
      },
      {
        q: "EquiSight è adatto anche per gli allevatori?",
        a: "Sì. EquiSight può essere configurato con funzionalità per l'allevamento come ciclo della cavalla, data di inseminazione, controllo gravidanza, dati dello stallone, pedigree, data prevista del parto e sviluppo del puledro. È esattamente l'area in cui la maggior parte delle app concorrenti non offre o offre pochissimo.",
      },
      {
        q: "Posso condividere i dati con il mio trainer o maniscalco?",
        a: "Sì. L'obiettivo di EquiSight è che le informazioni rilevanti possano essere condivise in modo sicuro con le persone che lavorano intorno al cavallo — trainer, maniscalco, dentista equino, veterinario, fisioterapista, stalliere o proprietario. Ogni persona riceve solo i permessi necessari per il suo ruolo.",
      },
      {
        q: "Perché non usare semplicemente WhatsApp o Excel?",
        a: "WhatsApp ed Excel funzionano finché le cose restano semplici. Non appena hai più cavalli, appuntamenti, documenti, trattamenti, proprietari o dati di allevamento, diventa facile sbagliare: le informazioni si disperdono, recuperarle richiede tempo e gli accordi verbali svaniscono. Un'app di gestione cavalli raccoglie tutto per ogni cavallo, con promemoria automatici.",
      },
      {
        q: "Quanto costa EquiSight?",
        a: "Puoi iniziare gratuitamente con 1 cavallo. Se vuoi gestire più cavalli, attivare le funzionalità di allevamento o dare accesso ai professionisti, esistono piani Premium convenienti. Consulta le opzioni aggiornate nella pagina dei prezzi.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Software allevamento cavalli: confronto completo 2026",
      description: "Confronta i software per l'allevamento equino: ciclo della fattrice, gravidanza, scelta dello stallone e puledri. Scopri perché EquiSight è l'app completa per l'allevamento.",
      keywords: [
        "software allevamento cavalli",
        "app ciclo fattrice",
        "app gravidanza fattrice",
        "app registrazione puledri",
        "app studbook cavallo",
        "pianificazione monta cavallo",
        "app scelta stallone",
      ],
    },
    hero: {
      eyebrow: "Guida alla scelta · software allevamento",
      breadcrumbLabel: "Software allevamento",
      title: "Software per l'allevamento equino: il confronto completo per il 2026.",
      intro: "Una fattrice merita più di una generica app di gestione cavalli. Confronta le funzioni di allevamento degli strumenti più noti, scopri cosa conta davvero e scegli consapevolmente il software adatto alla tua scuderia — grande o piccola.",
      pills: [
        {
          icon: "Baby",
          label: "Ciclo della fattrice",
        },
        {
          icon: "Heart",
          label: "Controllo gravidanza",
        },
        {
          icon: "Sparkles",
          label: "Sviluppo del puledro",
        },
        {
          icon: "FileText",
          label: "Studbook",
        },
      ],
      ctas: [
        {
          label: "Inizia gratuitamente con il modulo allevamento",
          href: "#start",
          primary: true,
        },
        {
          label: "Vai alla tabella comparativa",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Perché una comune app di gestione cavalli non basta per l'allevamento.",
      lead: "La maggior parte delle app equestri è progettata per un singolo cavallo sportivo o da ricreazione. L'allevamento ha un ritmo completamente diverso: estro, inseminazione, controllo gravidanza, ecografie, calendario puledri, pedigree e vendita. Un Excel si perde dopo 2 stagioni — e con più fattrici si perde il controllo.",
      items: [
        "Quando era l'ultimo ciclo di Bonita?",
        "Quale stallone è previsto per la monta della prossima stagione?",
        "L'ecografia dei 21 giorni è già programmata?",
        "Quali puledri del 2024 sono già stati venduti?",
        "Dov'è il diagramma del pedigree fino al nonno materno?",
        "Dove sono i campioni del DNA e i dati del passaporto?",
      ],
    },
    what: {
      title: "Cos'è il software per l'allevamento equino?",
      lead: "Il software per l'allevamento è una scheda specializzata per ogni fattrice e stallone, combinata con un calendario dell'anno di allevamento, pianificazione della gravidanza, registrazione dei puledri e visualizzazione del pedigree. Non un semplice registro equino, ma uno strumento che comprende il ciclo riproduttivo: dal primo estro allo svezzamento.",
      targetGroupsTitle: "Per quale tipo di allevatore è pensato il software di allevamento?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Allevatore hobbista (1-3 fattrici)",
          body: "Una o due monte all'anno — panoramica senza acrobazie su Excel.",
        },
        {
          icon: "Building2",
          title: "Piccola scuderia (4-10 fattrici)",
          body: "Un piano annuale di allevamento con ciclo, inseminazione, controlli gravidanza e scheda puledro.",
        },
        {
          icon: "Users",
          title: "Scuderia professionale (10+)",
          body: "Più collaboratori, scelta dello stallone per ogni fattrice, vendita e marketing.",
        },
        {
          icon: "Target",
          title: "Proprietario di stallone",
          body: "Storico degli ordini, statistiche del seme e agenda per stallone.",
        },
        {
          icon: "Heart",
          title: "Trasferimento embrionale",
          body: "Donatrice + ricevente come schede collegate, calendario TE.",
        },
        {
          icon: "ClipboardList",
          title: "Registrazione studbook",
          body: "Campioni del DNA, documenti del passaporto e dati del pedigree.",
        },
      ],
    },
    criteria: {
      title: "Cosa deve offrire un buon software per l'allevamento?",
      lead: "Non tutte le 'funzioni di allevamento' nelle app equestri sono uguali. Cinque aree chiave dove gli allevatori perdono molto tempo — e dove il software fa davvero la differenza.",
      items: [
        {
          icon: "Calendar",
          title: "Ciclo della fattrice ed estro",
          body: "Registro giornaliero, ovulazione predittiva, progressione per ciclo e promemoria automatici.",
        },
        {
          icon: "Heart",
          title: "Inseminazione e controllo gravidanza",
          body: "Date di monta e inseminazione, dati dello stallone, ecografia a 14, 21 e 60 giorni e determinazione del sesso.",
        },
        {
          icon: "Baby",
          title: "Sviluppo del puledro",
          body: "Dati di nascita, grafico del peso, piano di sverminazione, momento dello svezzamento, registrazione del passaporto.",
        },
        {
          icon: "FileText",
          title: "Pedigree e documenti",
          body: "Visualizzazione del pedigree fino a 4-5 generazioni, DNA, numeri di passaporto e stato nello studbook.",
        },
        {
          icon: "Target",
          title: "Scelta dello stallone e abbinamento",
          body: "Filtra per disciplina, linee di sangue, dati dello stallone e successi storici — non solo ciò che promuove il proprietario.",
        },
        {
          icon: "Share2",
          title: "Collaborazione con veterinario/inseminatore",
          body: "Ecografie, campioni e stati condivisi direttamente con lo studio che segue le tue fattrici.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs altri software per l'allevamento.",
      lead: "I risultati di ricerca italiani per software di allevamento mostrano spesso app generiche per cavalli che menzionano l'allevamento in una sola riga. Confrontiamo onestamente quali strumenti hanno davvero un flusso completo per l'allevamento.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Inizia gratuitamente",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Registrazione ciclo fattrice",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Data inseminazione + stallone",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ecografie e controllo gravidanza",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Data prevista del parto",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Scheda puledro (peso/crescita)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pedigree fino a 4-5 generazioni",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA e registrazione passaporto",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Scelta stallone / abbinamento",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "TE / trasferimento embrionale",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Panoramica multi-fattrice",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobile (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Condivisione con veterinario",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrato con scheda generale",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vendita e marketing dei puledri",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Confronto basato su funzionalità pubblicamente disponibili a gennaio 2026. EquineGenie è solido nell'allevamento, ma meno nel mobile e nella gestione generale del cavallo. EquiSight combina entrambi.",
    },
    why: {
      title: "Perché EquiSight serve gli allevatori in modo diverso.",
      lead: "Molti allevatori usano un software di allevamento separato e un'app distinta per la gestione del cavallo. EquiSight combina entrambi — senza dover passare da un'app all'altra o inserire i dati due volte.",
      points: [
        {
          icon: "Heart",
          title: "La fattrice rimane anche un cavallo normale",
          body: "La fattrice ha un anno di allevamento e una scheda cavallo ordinaria — salute, vaccinazioni, maniscalco. Un'unica app, tutti i moduli.",
        },
        {
          icon: "Sparkles",
          title: "Predittivo anziché reattivo",
          body: "Previsione del ciclo, promemoria per le tappe della gravidanza e calendario puledri — automaticamente basati sui tuoi dati.",
        },
        {
          icon: "Share2",
          title: "Tutti attorno all'allevamento",
          body: "Inseminatore, proprietario di stallone, veterinario, acquirente, studbook — tutti con accesso e i giusti permessi.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Per disciplina · dal ciclo allo svezzamento",
      title: "Cosa contiene una scheda allevamento in EquiSight.",
      lead: "Per ogni fattrice ottieni una scheda di allevamento completa, collegata alla sua scheda cavallo ordinaria.",
      items: [
        "Registro giornaliero del ciclo con previsione",
        "Inseminazione/monta + dati dello stallone",
        "Timeline ecografie (14/21/60 giorni + sesso)",
        "Tappe della gravidanza con promemoria automatici",
        "Data prevista del parto e preparativi",
        "Scheda puledro dalla nascita",
        "Pedigree fino a nonni con navigazione cliccabile",
        "Campione DNA, passaporto, stato studbook",
        "Pipeline di vendita con elenco interessati",
        "Storico scelta stallone per fattrice",
      ],
      ctaLabel: "Scopri il modulo allevamento",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Per l'intera scuderia",
      title: "Panoramica per più fattrici e stalloni.",
      lead: "Quando allevi più di 2-3 fattrici, avere una visione d'insieme di tutti i cicli e le gravidanze diventa fondamentale.",
      cards: [
        {
          t: "Dashboard cicli",
          d: "Tutte le fattrici affiancate, con la fase del ciclo e la prossima azione.",
        },
        {
          t: "Pipeline gravidanze",
          d: "In quale tappa della gravidanza si trovano le varie fattrici?",
        },
        {
          t: "Calendario puledri",
          d: "Nascite previste per mese, con la logistica pianificata di conseguenza.",
        },
        {
          t: "Portfolio stalloni",
          d: "Stalloni propri o inseminatori fissi con storico degli ordini.",
        },
        {
          t: "Grafico pedigree",
          d: "Analisi degli antenati su più generazioni e linee di sangue.",
        },
        {
          t: "Dashboard vendite",
          d: "Quali puledri sono venduti, prenotati o ancora disponibili.",
        },
      ],
    },
    beforeAfter: {
      title: "Da Excel + agenda a EquiSight allevamento.",
      lead: "In concreto: ecco come cambia la tua stagione di allevamento.",
      rows: [
        {
          before: "Ciclo su appunti sparsi",
          after: "Registro giornaliero con previsione",
        },
        {
          before: "Ecografie via WhatsApp all'inseminatore",
          after: "Scheda condivisa con foto",
        },
        {
          before: "Data gravidanza in agenda",
          after: "Promemoria automatici per le tappe",
        },
        {
          before: "Passaporto del puledro in un cassetto",
          after: "Documento collegato al profilo del puledro",
        },
        {
          before: "Pedigree su carta",
          after: "Pedigree cliccabile fino a 4-5 generazioni",
        },
        {
          before: "Annuncio di vendita su Marktplaats",
          after: "Pipeline di vendita con lista degli interessati",
        },
      ],
    },
    helper: {
      title: "Quale software di allevamento fa per te?",
      lead: "5 domande per capire se hai bisogno di un'app di allevamento completa o se è sufficiente uno strumento per hobbisti.",
      questions: [
        {
          id: "mares",
          q: "Quante fattrici gestisci?",
          options: [
            {
              label: "1 fattrice",
              score: 1,
            },
            {
              label: "2-5 fattrici",
              score: 2,
            },
            {
              label: "Più di 5 fattrici",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Con quale frequenza allevi ogni anno?",
          options: [
            {
              label: "Occasionalmente (ogni qualche anno)",
              score: 0,
            },
            {
              label: "Ogni anno 1-2 monte",
              score: 2,
            },
            {
              label: "Ogni anno 3+ monte",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Come insemini/copri?",
          options: [
            {
              label: "Monta naturale",
              score: 1,
            },
            {
              label: "IA con seme fresco/refrigerato",
              score: 2,
            },
            {
              label: "TE o seme congelato",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Collabori con un veterinario/inseminatore?",
          options: [
            {
              label: "Una sola persona fissa",
              score: 1,
            },
            {
              label: "Più studi veterinari",
              score: 2,
            },
            {
              label: "Rete internazionale",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Cosa utilizzi attualmente per tenere traccia?",
          options: [
            {
              label: "Excel o carta",
              score: 1,
            },
            {
              label: "App generica di gestione cavalli",
              score: 2,
            },
            {
              label: "Niente di strutturato",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Uno strumento hobbistico o Excel è sufficiente — ma EquiSight resta utile.",
          body: "Per 1 fattrice con monta naturale ogni qualche anno, un modulo di allevamento avanzato è eccessivo. EquiSight parte gratuitamente e puoi attivare il modulo allevamento solo nell'anno in cui allevi — senza obbligo di upgrade.",
          cta: "Inizia gratuitamente",
        },
        mid: {
          title: "EquiSight allevamento è lo strumento giusto.",
          body: "Hai più fattrici o più metodi di riproduzione — le app generiche per cavalli non sono progettate per questo. EquiSight combina allevamento e cura generale, così non devi passare da uno strumento all'altro.",
          cta: "Scopri il modulo allevamento",
        },
        high: {
          title: "EquiSight è costruito per la tua scuderia.",
          body: "Più fattrici, TE o seme congelato, team internazionale — la maggior parte degli strumenti non regge. EquiSight scala fino al livello di scuderia professionale senza accumulare licenze aggiuntive.",
          cta: "Parlaci di un piano Scuderia",
        },
      },
    },
    faqTitle: "Domande frequenti sul software per l'allevamento",
    faq: [
      {
        q: "Qual è il miglior software per l'allevamento equino?",
        a: "Per 1 fattrice senza metodi riproduttivi complessi, molti strumenti sono sufficienti. A partire da 2-3 fattrici, con l'uso di IA o TE, o con la collaborazione di veterinari e studbook, un modulo di allevamento completo diventa fondamentale. EquiSight combina l'allevamento con la gestione generale del cavallo in un'unica app, così non devi passare da uno strumento all'altro.",
      },
      {
        q: "Quali funzioni di allevamento mi servono davvero?",
        a: "Come minimo: registro del ciclo, dati di inseminazione/monta, tappe del controllo gravidanza e scheda puledro. Opzionali ma potenti: visualizzazione del pedigree, archivio scelta stallone, DNA/passaporto e pipeline di vendita.",
      },
      {
        q: "EquiSight può prevedere il ciclo di una fattrice?",
        a: "Sì. EquiSight utilizza i dati dei cicli precedenti per mostrare l'ovulazione prevista, così puoi pianificare l'inseminazione o la monta nel momento giusto — senza dover fare calcoli ogni giorno.",
      },
      {
        q: "EquiSight funziona anche per il trasferimento embrionale?",
        a: "Sì. La donatrice e la fattrice ricevente ottengono schede collegate, calendario TE e tappe condivise con lo studio veterinario. Così non perdi nessuna scadenza nel complesso processo di TE.",
      },
      {
        q: "Posso importare i miei dati di allevamento esistenti?",
        a: "Puoi inserire cicli, monte e dati dei puledri manualmente oppure in blocco tramite CSV. Per gli allevamenti attivi con dati su più stagioni, ti aiutiamo con una migrazione una tantum.",
      },
      {
        q: "Come condivido la scheda con il mio veterinario o inseminatore?",
        a: "Ogni persona riceve un accesso con un ruolo specifico: veterinario, inseminatore, proprietario di stallone o funzionario studbook. Ognuno vede solo le informazioni necessarie per il suo ruolo — senza necessità di accesso completo.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Software per maneggio: confronto completo e guida alla scelta 2026",
      description: "Confronta il software per maneggi: lezioni, cavalieri, cavalli e amministrazione. Scopri quale app è adatta al tuo maneggio o pensione equestre.",
      keywords: [
        "software per maneggio",
        "app gestione scuderia",
        "software amministrazione maneggio",
        "pianificazione lezioni maneggio",
        "software pensione equestre",
        "amministrazione cavalieri",
        "amministrazione cavalli maneggio",
      ],
    },
    hero: {
      eyebrow: "Guida alla scelta · software per maneggio",
      breadcrumbLabel: "Software per maneggio",
      title: "Software per maneggio: la guida completa alla scelta per maneggi e pensioni equestri.",
      intro: "Pianificazione lezioni, gestione cavalieri, cura dei cavalli, fatturazione e comunicazione — un buon software per maneggio riunisce tutto in un'unica soluzione. Confronta le opzioni più diffuse e scopri quale è adatta alla tua scuderia o al tuo maneggio.",
      pills: [
        {
          icon: "Calendar",
          label: "Pianificazione lezioni",
        },
        {
          icon: "Users",
          label: "Cavalieri & clienti",
        },
        {
          icon: "Heart",
          label: "Cura dei cavalli",
        },
        {
          icon: "CreditCard",
          label: "Fatturazione",
        },
      ],
      ctas: [
        {
          label: "Richiedi una demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Vai alla tabella comparativa",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Perché gli strumenti separati rallentano un maneggio.",
      lead: "La maggior parte dei maneggi funziona con una serie di strumenti scollegati: pianificazione lezioni su una lavagna bianca, registrazione cavalieri in Excel, fatturazione in un secondo strumento, cura dei cavalli su WhatsApp e contatti con i proprietari tramite messaggi personali. Nelle settimane intense si creano doppie prenotazioni, fatture dimenticate o cavalli senza sapere quale cavaliere li monta.",
      items: [
        "Chi è in lezione adesso con Jasmine?",
        "Quale cavaliere non ha ancora pagato per marzo?",
        "Quale cavallo non può essere utilizzato questa settimana?",
        "Chi sono i contatti di emergenza degli allievi?",
        "Il proprietario di Stardust ha già ricevuto la fattura del maniscalco?",
        "Quale cavallo si trova in quale box?",
      ],
    },
    what: {
      title: "Cos'è il software per maneggio?",
      lead: "Il software per maneggio combina pianificazione lezioni, gestione cavalieri, cura dei cavalli, fatturazione e comunicazione in un unico strumento. Niente acrobazie con Excel o caos su WhatsApp, ma un'unica piattaforma dove il maneggio lavora e proprietari/cavalieri possono seguire tutto.",
      targetGroupsTitle: "A quale tipo di azienda è destinato il software per maneggio?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Piccolo maneggio (1-15 cavalli)",
          body: "Soprattutto pianificazione lezioni e pagamenti — amministrazione senza grattacapi.",
        },
        {
          icon: "Users",
          title: "Maneggio medio (15-40 cavalli)",
          body: "Più istruttori, pianificazione lezioni + turni cavalli + gestione cavalieri.",
        },
        {
          icon: "ClipboardList",
          title: "Grande scuderia da equitazione e pensione (40+)",
          body: "Operatività completa inclusa fatturazione, pianificazione alimentazione e maniscalco.",
        },
        {
          icon: "Heart",
          title: "Pensione equestre",
          body: "Portale proprietari, istruzioni di cura individuali, agenda condivisa.",
        },
        {
          icon: "Target",
          title: "Centro di addestramento ostacoli",
          body: "Pianificazione gare, allenamento per cavallo, contatto con i clienti.",
        },
        {
          icon: "FileText",
          title: "Imprenditori del settore equestre",
          body: "Mix di lezioni + pensione + clinic + commercio — tutto da un unico sistema.",
        },
      ],
    },
    criteria: {
      title: "Cosa deve offrire un buon software per maneggio?",
      lead: "Una bella app non vale nulla se i tuoi collaboratori non vogliono usarla. Cinque criteri pratici che fanno la differenza tra successo e frustrazione.",
      items: [
        {
          icon: "Calendar",
          title: "Pianificazione lezioni su più livelli",
          body: "Principiante/avanzato, dressage/salto ostacoli, abbinamenti cavallo-cavaliere e agende degli istruttori — tutto visibile contemporaneamente.",
        },
        {
          icon: "Users",
          title: "Gestione cavalieri",
          body: "Profili, livello, abbonamento, carnet lezioni e collegamenti familiari per i giovani cavalieri.",
        },
        {
          icon: "Heart",
          title: "Rotazione dei cavalli",
          body: "Quante volte viene impiegato ogni cavallo, con periodi di riposo, infortunio e recupero.",
        },
        {
          icon: "CreditCard",
          title: "Fatturazione & abbonamenti",
          body: "Abbonamenti mensili, carnet lezioni, lezioni singole e addebito automatico.",
        },
        {
          icon: "Share2",
          title: "Portale proprietari (pensione equestre)",
          body: "I proprietari vedono il loro cavallo nella propria app — agenda, costi, maniscalco e note senza dover telefonare.",
        },
        {
          icon: "Bell",
          title: "Comunicazione & promemoria",
          body: "Promemoria automatici per le lezioni, notifiche di pagamento, annunci del maniscalco — senza messaggi manuali.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs altri software per maneggio.",
      lead: "Molti strumenti per maneggi sono forti nella pianificazione lezioni o nella fatturazione, ma raramente nella cura dei cavalli e nella comunicazione con i proprietari allo stesso tempo. Li confrontiamo in modo obiettivo.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Inizio gratuito / periodo di prova",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Pianificazione lezioni",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Più istruttori",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Gestione cavalieri",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Rotazione cavalli",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cura cavalli (vacc/maniscalco)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Carnet lezioni / abbonamento",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pagamenti online",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Fatturazione automatica",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portale proprietari (pensione)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integrazione maniscalco/veterinario",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Promemoria WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobile (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pianificazione gare",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Adatto per pensione equestre",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Confronto basato sulle funzionalità pubblicamente disponibili a gennaio 2026. Stalmanager è forte nell'amministrazione, EquiSight si distingue per il flusso pensione equestre + cura cavalli + portale proprietari.",
    },
    why: {
      title: "Perché EquiSight è diverso per maneggi e pensioni equestri.",
      lead: "EquiSight va oltre un semplice pianificatore di lezioni. Vediamo un maneggio come un'operazione completa: cavalli, persone, comunicazione e finanze — tutti interdipendenti.",
      points: [
        {
          icon: "Heart",
          title: "Il cavallo al centro, non l'agenda",
          body: "Ogni cavallo ha la propria scheda. Impiego nelle lezioni, salute, maniscalco e gare in un'unica timeline — non 3 strumenti separati.",
        },
        {
          icon: "Share2",
          title: "I proprietari sempre aggiornati senza telefonate",
          body: "I proprietari della pensione equestre hanno la propria vista: costi, pianificazione, foto e note — risparmio di 5-10 telefonate a settimana.",
        },
        {
          icon: "Bell",
          title: "Comunicazione automatica",
          body: "Promemoria lezione, promemoria vaccinazione, fattura — automatici, via app/email/SMS. Niente più broadcast su WhatsApp.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Per la pensione equestre",
      title: "Cosa ottiene una pensione equestre con EquiSight.",
      lead: "Le pensioni equestri hanno sfide uniche che i normali software per maneggi non risolvono.",
      cards: [
        {
          t: "Portale proprietari",
          d: "Ogni proprietario vede solo il proprio cavallo (o i propri cavalli), l'agenda e i costi.",
        },
        {
          t: "Istruzioni di cura per cavallo",
          d: "Alimentazione, fieno, integratori, rotazione coperte — visibili per il personale della scuderia.",
        },
        {
          t: "Agenda condivisa",
          d: "Maniscalco, veterinario e visite dei proprietari in un'unica vista.",
        },
        {
          t: "Costi di consumo per cavallo",
          d: "Lettiera, foraggio, mangime addebitati per singolo proprietario.",
        },
        {
          t: "Contatti di emergenza del cavallo",
          d: "Proprietario + veterinario + maniscalco sempre reperibili per il personale.",
        },
        {
          t: "Gestione al pascolo",
          d: "Quali cavalli vanno al pascolo, in riposo o in riabilitazione?",
        },
      ],
    },
    beforeAfter: {
      title: "Dalla lavagna + Excel a EquiSight.",
      lead: "In concreto: così cambia una settimana lavorativa al maneggio.",
      rows: [
        {
          before: "Lavagna con la pianificazione lezioni",
          after: "Pianificazione in tempo reale per istruttore",
        },
        {
          before: "Excel con cavalieri e note sulle lezioni",
          after: "CRM clienti con storico lezioni",
        },
        {
          before: "WhatsApp ai proprietari",
          after: "Portale proprietari per il loro cavallo",
        },
        {
          before: "Addebito mensile manuale",
          after: "Fatturazione automatica + iDEAL",
        },
        {
          before: "Cura del cavallo su una lavagna di sughero",
          after: "Istruzioni di cura per cavallo, condivise",
        },
        {
          before: "Appuntamento verbale con il maniscalco",
          after: "Pianificazione maniscalco con conferme",
        },
      ],
    },
    helper: {
      title: "Quale software per maneggio fa per te?",
      lead: "5 domande per capire se EquiSight è la piattaforma giusta per il tuo maneggio o pensione equestre.",
      questions: [
        {
          id: "size",
          q: "Quanti cavalli hai nella tua struttura?",
          options: [
            {
              label: "Meno di 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "Più di 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Qual è la tua attività principale?",
          options: [
            {
              label: "Principalmente lezioni",
              score: 1,
            },
            {
              label: "Pensione equestre (cavalli a pensione)",
              score: 3,
            },
            {
              label: "Mix di lezioni + pensione",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Con quanti istruttori lavori?",
          options: [
            {
              label: "Solo io",
              score: 1,
            },
            {
              label: "2-3 istruttori",
              score: 2,
            },
            {
              label: "4 o più",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Come gestisci attualmente la fatturazione?",
          options: [
            {
              label: "Manualmente (Word/Excel)",
              score: 3,
            },
            {
              label: "Programma di contabilità separato",
              score: 2,
            },
            {
              label: "Integrato nello strumento lezioni",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Come comunichi con i proprietari?",
          options: [
            {
              label: "Di persona / WhatsApp",
              score: 3,
            },
            {
              label: "Email + WhatsApp",
              score: 2,
            },
            {
              label: "Portale proprietari nello strumento",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Uno strumento leggero o Excel può bastare per ora — ma EquiSight cresce con te.",
          body: "Per una piccola struttura con un solo istruttore e poca pensione, un pacchetto completo non è immediatamente necessario. EquiSight parte gratuitamente e cresce insieme al tuo maneggio — nessun mal di testa per la migrazione tra qualche anno.",
          cta: "Inizia gratis",
        },
        mid: {
          title: "EquiSight è un upgrade logico per il tuo maneggio.",
          body: "Più istruttori, un mix di lezioni e pensione, o una fatturazione attualmente separata — EquiSight riunisce tutto in un unico flusso di lavoro. Il portale proprietari in particolare riduce notevolmente le comunicazioni ad hoc.",
          cta: "Richiedi una demo",
        },
        high: {
          title: "EquiSight è pensato per la tua dimensione.",
          body: "Pensione equestre + lezioni + più istruttori è esattamente il contesto in cui EquiSight si distingue dagli strumenti tradizionali per maneggi. Il portale proprietari e l'integrazione della cura dei cavalli fanno risparmiare ore di amministrazione e comunicazione ogni settimana.",
          cta: "Pianifica una demo per la tua scuderia",
        },
      },
    },
    faqTitle: "Domande frequenti sul software per maneggio",
    faq: [
      {
        q: "Qual è il miglior software per maneggio?",
        a: "Per la pura pianificazione delle lezioni esistono diverse buone opzioni. Non appena hai bisogno di una pensione equestre, di più istruttori o del monitoraggio della cura dei cavalli, EquiSight diventa la soluzione completa — niente acrobazie tra strumenti diversi, tutto in un unico posto.",
      },
      {
        q: "Posso importare i clienti e le lezioni esistenti?",
        a: "Sì. I dati dei clienti e gli orari delle lezioni possono essere importati tramite CSV. Aiutiamo i maneggi attivi con una migrazione una tantum, così non devi inserire manualmente 200 cavalieri.",
      },
      {
        q: "Funziona anche per una pensione equestre senza lezioni?",
        a: "Sì. La modalità pensione equestre disattiva le lezioni e si concentra sul portale proprietari, alimentazione/cura, pianificazione del maniscalco e addebito dei costi per cavallo.",
      },
      {
        q: "I cavalieri possono iscriversi e pagare autonomamente?",
        a: "Sì. I cavalieri possono tramite il proprio account vedere quali lezioni sono disponibili, iscriversi, pagare le lezioni con iDEAL e acquistare carnet lezioni.",
      },
      {
        q: "Come viene gestita la privacy dei dati di cavalli e proprietari?",
        a: "Ogni persona ha un ruolo (proprietario, cavaliere, istruttore, collaboratore). Per ogni ruolo si vedono solo le informazioni necessarie. I proprietari vedono solo il loro cavallo, i cavalieri solo le proprie lezioni.",
      },
      {
        q: "EquiSight può integrarsi con il mio software di contabilità?",
        a: "Sì, sono disponibili integrazioni con Exact, Moneybird e e-Boekhouden. Le fatture vengono così trasmesse automaticamente alla tua contabilità.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "App allenatore cavallo: confronto e guida alla scelta per coach 2026",
      description: "Confronta le app per allenatori di cavallo e cavaliere: diario di allenamento, video, obiettivi, analisi protocolli e gestione clienti. Trova lo strumento giusto per i coach.",
      keywords: [
        "app allenatore cavallo",
        "app istruttore equitazione",
        "app allenamento cavallo",
        "app coaching cavaliere",
        "diario allenamento cavallo",
        "analisi protocollo dressage",
        "software addestratore cavalli",
      ],
    },
    hero: {
      eyebrow: "Guida alla scelta · software per allenatori",
      breadcrumbLabel: "App allenatore",
      title: "App allenatore cavallo: guida completa alla scelta per istruttori e coach.",
      intro: "Un allenatore o istruttore gestisce combinazioni, lezioni, video, obiettivi e gare. Confronta le migliori app per gli operatori del mondo equestre e scegli la piattaforma che continuerà a crescere con il tuo coaching anche nel 2026.",
      pills: [
        {
          icon: "Target",
          label: "Obiettivi e pianificazione",
        },
        {
          icon: "Video",
          label: "Analisi video",
        },
        {
          icon: "TrendingUp",
          label: "Progressi",
        },
        {
          icon: "Users",
          label: "Clienti/combinazioni",
        },
      ],
      ctas: [
        {
          label: "Inizia gratis come allenatore",
          href: "#start",
          primary: true,
        },
        {
          label: "Vai alla tabella di confronto",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Perché il coaching via WhatsApp ostacola gli allenatori.",
      lead: "La maggior parte degli allenatori lavora con strumenti separati: WhatsApp per la comunicazione, un taccuino per le lezioni, YouTube o WeTransfer per i video e Excel per i risultati di gara. Con 5 cavalieri funziona. Con 20 cavalieri le informazioni si perdono, si dimenticano gli obiettivi e si perde il controllo sui progressi individuali.",
      items: [
        "Qual è l'obiettivo di Anouk per questa stagione?",
        "Quale video ho mandato a Bram il mese scorso?",
        "Lara ha visto l'analisi del protocollo della sua ultima gara?",
        "Quale combinazione si allena quante volte a settimana?",
        "Il proprietario di Stardust ha letto le mie istruzioni di allenamento?",
        "Quando è stata l'ultima volta che ho dato un feedback sull'impulso variabile?",
      ],
    },
    what: {
      title: "Cos'è un'app allenatore per cavallo e cavaliere?",
      lead: "Un'app per allenatori combina un CRM di coaching (combinazioni, lezioni, obiettivi), un diario di allenamento per cavallo, feedback video, pianificazione gare e analisi protocolli. Niente più WhatsApp/YouTube/Excel separati, ma un'unica piattaforma in cui allenatore e cavaliere lavorano insieme.",
      targetGroupsTitle: "Per quale tipo di allenatore è pensato?",
      targetGroups: [
        {
          icon: "Target",
          title: "Istruttore di dressage",
          body: "Scansiona i protocolli, collega i commenti della giuria agli obiettivi di allenamento, monitora i progressi.",
        },
        {
          icon: "Activity",
          title: "Trainer di salto ostacoli",
          body: "Pianificazione percorsi, feedback sui round, gestione delle altezze per cavallo.",
        },
        {
          icon: "Award",
          title: "Coach di eventing",
          body: "Tre discipline, tre pianificazioni — tutte visibili fianco a fianco.",
        },
        {
          icon: "TrendingUp",
          title: "Performance coach (sport)",
          body: "Monitoraggio EPI, gare, obiettivi — per atleti di alto livello e i loro team.",
        },
        {
          icon: "Users",
          title: "Istruttore di maneggio",
          body: "Lezioni di gruppo e coaching individuale in un'unica app.",
        },
        {
          icon: "Heart",
          title: "Coach ricreativo",
          body: "Ippoterapia, principianti, proprietari con un solo cavallo.",
        },
      ],
    },
    criteria: {
      title: "Cosa deve avere una buona app per allenatori?",
      lead: "Allenare è una questione umana, ma lo strumento giusto ti rende del 30-50% più efficiente e aiuta i cavalieri a migliorare anche tra una lezione e l'altra.",
      items: [
        {
          icon: "Users",
          title: "Gestione combinazioni",
          body: "Cavallo + cavaliere come un'unica unità, con livello, obiettivi, progressi e storico.",
        },
        {
          icon: "ClipboardList",
          title: "Note lezioni e obiettivi",
          body: "Una nota per ogni lezione con punti chiave, collegata a obiettivi a lungo termine.",
        },
        {
          icon: "Video",
          title: "Feedback video",
          body: "Carica un video, tagga i momenti, aggiungi feedback vocale o scritto.",
        },
        {
          icon: "Target",
          title: "Analisi gare e protocolli",
          body: "Scansiona i protocolli (KNHS/FEI), visualizza i punteggi per elemento, commenti della giuria e tendenze.",
        },
        {
          icon: "Calendar",
          title: "Pianificazione e carnet di lezioni",
          body: "Agenda, pagamenti, abbonamenti e promemoria automatici.",
        },
        {
          icon: "Share2",
          title: "Comunicazione al cavaliere",
          body: "Il cavaliere vede la propria pagina con lezioni, video, obiettivi e feedback.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs altre app per allenatori.",
      lead: "Alcuni strumenti per allenatori si concentrano sulla sostituzione di WhatsApp, altri sull'analisi dei protocolli. EquiSight combina entrambe le cose con un vero fascicolo del cavallo — così il cavaliere migliora anche tra una lezione e l'altra.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Inizia gratis",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Gestione combinazioni",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Note lezioni e feedback",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Obiettivi a lungo termine",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Upload video + feedback",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Scansione protocolli KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Indice di Performance)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Calendario gare",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portale cavaliere",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Carnet lezioni / abbonamento",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Pagamenti online",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Fascicolo cavallo integrato",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Maniscalco/veterinario visibili",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Per istruttore E cavaliere",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Multi-cavallo per cavaliere",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Confronto basato sulle funzionalità pubblicamente disponibili a gennaio 2026. EquiSight è unico nell'analisi dei protocolli + EPI e combina questo con la gestione generale del cavallo.",
    },
    why: {
      title: "Perché EquiSight offre un'esperienza di coaching diversa.",
      lead: "La maggior parte degli strumenti per allenatori si ferma quando finisce la lezione. EquiSight continua — nel fascicolo del cavallo, nell'analisi delle gare, nella collaborazione con il veterinario e il proprietario.",
      points: [
        {
          icon: "TrendingUp",
          title: "Scansione protocollo → obiettivo di allenamento",
          body: "Scansiona un protocollo KNHS e vedi subito quali elementi richiedono attenzione. Gli obiettivi emergono automaticamente.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach potenzia il tuo occhio clinico",
          body: "I dati di più lezioni, gare e protocolli rivelano schemi che non riesci a tenere a mente.",
        },
        {
          icon: "Share2",
          title: "Integrato con il cavallo",
          body: "L'allenatore vede vaccinazioni, maniscalco e storico degli infortuni del cavallo — nessun piano di allenamento durante il recupero.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Per dressage e salto ostacoli",
      title: "Cosa contiene un fascicolo di coaching in EquiSight.",
      lead: "Per ogni combinazione hai uno stream di coaching che tiene tutto insieme — niente più cose perse in WhatsApp.",
      items: [
        "Note lezione con punti chiave per sessione",
        "Obiettivi a lungo termine + traguardi",
        "Upload video con commenti al timecode",
        "Scansione protocollo KNHS/FEI con punteggi",
        "Commenti della giuria collegati all'allenamento",
        "Risultati di gara e andamento EPI",
        "Contatto cliente e storico lezioni",
        "Carnet lezioni / abbonamento / fatture",
        "Grafico dei progressi per disciplina",
        "Accesso condiviso con il proprietario del cavallo",
      ],
      ctaLabel: "Scopri il modulo allenatore",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Da WhatsApp + YouTube a EquiSight Trainer.",
      lead: "In concreto: ecco come cambia il tuo flusso di lavoro nel coaching.",
      rows: [
        {
          before: "WhatsApp con link video sparsi",
          after: "Video con feedback al timecode nel fascicolo",
        },
        {
          before: "Taccuino per ogni cavaliere",
          after: "Log di coaching con obiettivi e cronologia",
        },
        {
          before: "Excel con punteggi di gara",
          after: "Grafico EPI + analisi protocollo",
        },
        {
          before: "Obiettivi comunicati a voce",
          after: "Traguardi con indicatore di progressione",
        },
        {
          before: "Strumento di fatturazione separato",
          after: "Lezioni + iDEAL + abbonamento nell'app",
        },
        {
          before: "Email al proprietario sui progressi",
          after: "Il proprietario segue tutto nella propria vista",
        },
      ],
    },
    helper: {
      title: "Quale app per allenatori fa per te?",
      lead: "5 domande per capire se uno strumento di coaching specializzato aggiunge valore alla tua attività.",
      questions: [
        {
          id: "clients",
          q: "Quante combinazioni attive alleni?",
          options: [
            {
              label: "Meno di 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Più di 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Qual è la tua disciplina principale?",
          options: [
            {
              label: "Dressage",
              score: 3,
            },
            {
              label: "Salto ostacoli",
              score: 2,
            },
            {
              label: "Ricreativo / vario",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Usi il video nel coaching?",
          options: [
            {
              label: "Raramente",
              score: 0,
            },
            {
              label: "A volte (manualmente)",
              score: 2,
            },
            {
              label: "Spesso — in modo strutturato",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Alleni cavalieri agonisti?",
          options: [
            {
              label: "No, solo ricreativi",
              score: 0,
            },
            {
              label: "A volte in gara",
              score: 2,
            },
            {
              label: "Spesso — le gare sono centrali",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Vuoi misurare il tuo coaching?",
          options: [
            {
              label: "No, l'intuizione è sufficiente",
              score: 0,
            },
            {
              label: "Sì, ma non ho tempo",
              score: 2,
            },
            {
              label: "Sì — coaching basato sui dati",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Uno strumento semplice o anche WhatsApp sono sufficienti — per ora.",
          body: "Per meno di 5 cavalieri senza molto video o gare, un'app di coaching è superflua. EquiSight inizia gratuitamente, quindi puoi provarlo quando la tua attività cresce.",
          cta: "Inizia gratis",
        },
        mid: {
          title: "EquiSight Trainer ti rende strutturalmente più efficiente.",
          body: "Con 5-15 combinazioni perdi ore ogni mese su WhatsApp e video sparsi. EquiSight raccoglie tutto in un posto, scansiona i protocolli automaticamente e fa sì che i cavalieri possano sempre rivedere il loro feedback.",
          cta: "Prova il modulo Trainer",
        },
        high: {
          title: "EquiSight è costruito per la tua scala di coaching.",
          body: "Molti cavalieri, video, gare e coaching basato sui dati: è esattamente qui che EquiSight si distingue. EPI + scansione protocolli + fascicolo del cavallo ti danno un vantaggio che i concorrenti non hanno.",
          cta: "Prenota una demo per la tua attività di coaching",
        },
      },
    },
    faqTitle: "Domande frequenti sulle app per allenatori",
    faq: [
      {
        q: "Qual è la migliore app per allenatori di cavallo e cavaliere?",
        a: "Per la pura comunicazione molti strumenti sono sufficienti (anche WhatsApp). Per obiettivi, analisi video, scansione protocolli, monitoraggio gare e gestione clienti in un unico strumento, EquiSight è la soluzione più completa — soprattutto perché tiene traccia anche del cavallo stesso, non solo della combinazione.",
      },
      {
        q: "EquiSight può leggere automaticamente i protocolli di gara?",
        a: "Sì. Carica un protocollo KNHS o FEI e EquiSight estrae i punteggi per elemento, i commenti della giuria e li collega alla combinazione. Puoi vedere le tendenze su più gare.",
      },
      {
        q: "Cos'è l'EPI (Equestrian Performance Index)?",
        a: "L'EPI è un punteggio EquiSight che converte più risultati di gara in un indice di prestazione comparabile. In questo modo vedi i veri progressi attraverso diverse classi e giurie.",
      },
      {
        q: "I cavalieri possono prenotare e pagare le lezioni da soli?",
        a: "Sì. I cavalieri si connettono, vedono gli orari disponibili, acquistano carnet di lezioni e pagano tramite iDEAL. Tu decidi cosa vuoi offrire e approvi o rifiuti.",
      },
      {
        q: "Funziona anche per un istruttore che lavora in un maneggio?",
        a: "Sì. Puoi lavorare come istruttore freelance con i tuoi clienti senza collegare un account maneggio. I clienti ti pagano direttamente.",
      },
      {
        q: "Posso migrare video e note esistenti?",
        a: "I video possono essere caricati per combinazione o tramite uno strumento di caricamento in batch. Le note si importano tramite CSV. Aiutiamo gli allenatori attivi con una migrazione una tantum.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Guide e strumenti di scelta per software di gestione equestre | EquiSight",
      description: "Tutte le guide EquiSight in un unico posto: confronti di software per gestione equestre, allevamento, maneggio e trainer, più strumenti di scelta per il 2026.",
      keywords: [
        "guide software equestre",
        "strumento di scelta gestione cavalli",
        "confronto software allevamento",
        "guida software maneggio",
        "confronto app trainer equestre",
      ],
    },
    hub: {
      eyebrow: "Hub · guide",
      breadcrumbLabel: "Guide",
      title: "Quattro guide complete per scegliere il software equestre giusto.",
      intro: "Uno strumento di scelta approfondito per ogni tipo di utente: tabelle comparative, criteri, esempi e quiz interattivo. Clicca sulla guida più adatta alla tua situazione, oppure esplora prima gli articoli di approfondimento sotto ogni cluster.",
      stats: {
        guides: "4 strumenti di scelta",
        articles: "15 articoli di approfondimento",
        fair: "Confronto imparziale",
      },
      readMoreCta: "Leggi la guida completa",
      relatedHeading: "Articoli di approfondimento",
      articlesCountSingular: "{{count}} articolo di approfondimento",
      articlesCountPlural: "{{count}} articoli di approfondimento",
      articlesCountAria: "Numero di articoli del cluster",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Strumento di scelta app per la gestione equestre",
        blurb: "Confronta le app di gestione equestre più conosciute e scopri quale si adatta meglio a proprietari, scuderie o allevamenti. Include una tabella comparativa imparziale e uno strumento di scelta in 5 domande.",
        audience: "Per proprietari, gestori di scuderie e tutti gli appassionati di cavalli che cercano chiarezza.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Confronto software per l'allevamento equestre",
        blurb: "Dal ciclo della fattrice allo sviluppo del puledro: scopri quale software per l'allevamento funziona davvero per il tuo numero di fattrici, metodo di riproduzione e requisiti del registro.",
        audience: "Per allevatori (amatoriali e professionali), haras e proprietari di stalloni.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Strumento di scelta software per maneggio",
        blurb: "Pianificazione delle lezioni, amministrazione dei cavalieri, portale proprietari e fatturazione — tutto in un unico strumento. Confronta le opzioni per maneggi e scuderie a pensione nel 2026.",
        audience: "Per maneggi, scuderie a pensione e aziende equestri.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Strumento di scelta app per trainer equestre",
        blurb: "CRM per il coaching, feedback video, scansione del protocollo KNHS e obiettivi per ogni combinazione cavallo-cavaliere. Quale app per trainer si adatta alla tua attività di coaching?",
        audience: "Per istruttori, trainer e coach.",
      },
    ],
    closing: {
      eyebrow: "Perché queste guide",
      title: "Confronto onesto, non solo prezzi.",
      body1: "Molte \"pagine di confronto\" sono pubblicità camuffate. Le nostre guide mettono a confronto funzionalità, pubblico di riferimento e concorrenti come farebbe una fonte di conoscenza indipendente. EquiSight emerge naturalmente come soluzione completa, ma leggi anche onestamente dove altre app eccellono.",
      body2: "Gli articoli di approfondimento sotto ogni guida rispondono alle domande concrete che nascono dalla scelta: \"Quando fare il primo esame ecografico dopo l'inseminazione\", \"Come automatizzare la fatturazione del maneggio\", \"Come analizzare un protocollo di gara\". Niente marketing vuoto, solo pratica concreta.",
    },
    hubName: "Guide EquiSight",
  },
  ui: {
    sectionEyebrows: {
      pains: "Perché questo fa male",
      basics: "Le basi",
      criteria: "Cosa lo rende buono?",
      comparison: "Confronto onesto",
      why: "La differenza",
      beforeAfter: "Dal disordine alla chiarezza",
      helper: "5 domande",
    },
    table: {
      feature: "Funzione",
      today: "Oggi",
      withEquisight: "Con EquiSight",
    },
    helper: {
      questionLabel: "Domanda {{current}} di {{total}}",
      answerPrompt: "Rispondi alla {{count}} domanda rimanente per vedere un consiglio.",
      answerPromptPlural: "Rispondi alle {{count}} domande rimanenti per vedere un consiglio.",
      resultEyebrow: "Il tuo risultato",
    },
    targetGroupsFallback: "A chi è destinato?",
    faqTitleFallback: "Domande frequenti",
  },
};

export default CORNERSTONES;
